<script>
  import Timestamp from "./Timestamp.svelte";
  import Editor from "./Editor.svelte";
  import Files from "./Files.svelte";
  import Tag from "./Tag.svelte";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  function remove() {
    dispatch("remove", { id });
  }

  function collapse() {
    collapsed = !collapsed;
    dispatch("collapse", { id, collapsed });
  }

  function updateBody(event) {
    const { newBody } = event.detail;
    dispatch("updateBody", {
      id,
      newBody,
    });
  }

  function addTag(e) {
    const newTag = e.target.firstChild.value;
    e.target.firstChild.value = "";
    const newTags = [...tags, newTag];
    tags = newTags;

    dispatch("setTags", {
      id,
      tags: newTags,
    });
  }

  function removeTag(tag) {
    const newTags = tags.filter((t) => t !== tag);
    tags = newTags;

    dispatch("setTags", {
      id,
      tags: newTags,
    });
  }

  export let id; // document ID
  export let body;
  export let time;
  export let files;
  export let tags;
  export let collapsed;
  export let allTags;
</script>

<div class="note" class:collapsed>
  <div class="note-top">
    <div class="tags">
      {#each tags as tag}
        <Tag {tag} on:click={() => removeTag(tag)} />
      {/each}
      <form class="tag-form" on:submit|preventDefault={(e) => addTag(e)}>
        <input list="allTags" name="tag" class="add-tag" type="text" placeholder="Add Tag" />
        <datalist id="allTags">
          {#each allTags as tag}
            <option value={tag} />
          {/each}
        </datalist>
      </form>
    </div>
    <div class="actions">
      <button on:click={remove} class="action delete"><i class="las la-trash-alt"></i></button>
    </div>
  </div>
  <div class="note-bottom">
    <div class="sidebar">
      <Timestamp timestamp={time} />
      <button on:click={collapse} class="action collapse"><i class="las la-caret-square-up"></i></button>
    </div>
    <div class="body">
      <Editor {body} on:updateBody={updateBody} {collapsed} />
      <Files noteId={id} files={files} on:setFiles />
    </div>
  </div>
</div>

<style>
  .note {
    margin-bottom: 1rem;
    background-color: #25282a;
    border: 1px solid #524c4c;
    border-radius: 4px;
  }

  .note-top {
    border-bottom: 1px solid #524c4c;
    justify-content: space-between;
  }
  .tags {
  }

  .tag-form {
    display: inline;
  }
  .add-tag {
    background-color: transparent;
    color: #ddd7d7;
    border: 0;
    border-radius: 0;
    max-width: 12ch;
    font-size: 0.75rem;
    padding-left: 0.25rem;
  }

  .note-top,
  .note-bottom {
    display: flex;
    padding: 0.75rem 0.75rem 0.5rem 0.75rem;
  }

  .sidebar {
    max-width: 80px;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }

  .action {
    border: none;
    font-size: 24px;
    max-height: none;
  }

  .actions button {
    padding: 0;
    transform: translateY(-3px);
  }

  .collapsed .action.collapse {
    transform: rotate(180deg);
  }

  .body {
    width: calc(100% - 80px);
    margin-left: 1rem;
    flex-grow: 1;
  }

  :global(.las) {
    cursor: pointer;
    color: rgba(231, 231, 241, 0.5);
  }

  :global(.las:hover) {
    color: #06c;
  }
</style>
